export default [{
  name: "Jim Vandehei",
  title: "Founder & Chief Executive Officer",
  picture: "//static.axios.com/img/headshots/JimVandehei.jpg"
}, {
  name: "Mike Allen",
  title: "Founder & Executive Editor",
  picture: "//static.axios.com/img/headshots/MikeAllen.jpg"
}, {
  name: "Roy Schwartz",
  title: "Founder & President",
  picture: "//static.axios.com/img/headshots/RoySchwartz.jpg"
}, {
  name: "Evan Ryan",
  title: "Executive Vice President",
  picture: "//static.axios.com/img/headshots/evan_ryan.jpg"
}, {
  name: "Alexis Lloyd",
  title: "Chief Design Officer",
  picture: "//static.axios.com/img/headshots/AlexisLloyd.jpg"
}, {
  name: "Matt Boggie",
  title: "Chief Technology Officer",
  picture: "//static.axios.com/img/headshots/MattBoggie.jpg"
}, {
  name: "Kendra Tucker",
  title: "Senior Vice President, Audience and Platforms",
  picture: "//static.axios.com/img/headshots/kendra_tucker.jpg"
}, {
  name: "Nicholas Johnston",
  title: "Editor in Chief",
  picture: "//static.axios.com/img/headshots/NicholasJohnston.jpg"
}, {
  name: "Abby Clawson",
  title: "Vice President, Finance and Accounting",
  picture: "//static.axios.com/img/headshots/abby-clawson.jpg"
}, {
  name: "Adam Hirsch",
  title: "Systems Architect",
  picture: "//static.axios.com/img/headshots/adam-hirsch.jpg"
}, {
  name: "Adams Paschal",
  title: "Associate Director, External Affairs",
  picture: "//static.axios.com/img/headshots/adams-paschal.jpg"
}, {
  name: "AJ Frucci",
  title: "Vice President, Business Development",
  picture: "//static.axios.com/img/headshots/aj-frucci.jpg"
}, {
  name: "Alayna Treene",
  title: "News Reporter",
  picture: "//static.axios.com/img/headshots/AlaynaTreene.jpg"
}, {
  name: "Alex Duner",
  title: "Front-End Developer",
  picture: "//static.axios.com/img/headshots/alex-duner.jpg"
}, {
  name: "Alexi McCammond",
  title: "Associate Editor, News",
  picture: "//static.axios.com/img/headshots/alexi-mccammond.jpg"
}, {
  name: "Ali Rubin",
  title: "Senior Vice President, External Affairs",
  picture: "//static.axios.com/img/headshots/AliRubin.jpg"
}, {
  name: "Alison Snyder",
  title: "Science Editor",
  picture: "//static.axios.com/img/headshots/alison-snyder.jpg"
}, {
  name: "Amy Harder",
  title: "Energy Reporter",
  picture: "//static.axios.com/img/headshots/amy-harder.jpg"
}, {
  name: "Andrew Witherspoon",
  title: "Visual Journalist, Data Visualization",
  picture: "//static.axios.com/img/headshots/andrew-witherspoon.jpg"
}, {
  name: "Andy Boyle",
  title: "Director of Platform Architecture",
  picture: "//static.axios.com/img/headshots/andy-boyle.jpg"
}, {
  name: "Ben Geman",
  title: "Energy Reporter",
  picture: "//static.axios.com/img/headshots/ben-geman.jpg"
}, {
  name: "Bob Herman",
  title: "Health Care Business Reporter",
  picture: "//static.axios.com/img/headshots/bob-herman.jpg"
}, {
  name: "Brian Jacobel",
  title: "Front-End Developer",
  picture: "//static.axios.com/img/headshots/brian-jacobel.jpg"
}, {
  name: "Brittney Sceals",
  title: "Recruiter",
  picture: "//static.axios.com/img/headshots/brittney-sceals.jpg"
}, {
  name: "Bubba Atkinson",
  title: "Managing Editor, Social/Video",
  picture: "//static.axios.com/img/headshots/BubbaAtkinson.jpg"
}, {
  name: "Caitlin Owens",
  title: "Health Care Reporter",
  picture: "//static.axios.com/img/headshots/CaitlinOwens.jpg"
}, {
  name: "Caresse Haaser",
  title: "Motion Graphics Designer",
  picture: "//static.axios.com/img/headshots/caresse-haaser.jpg"
}, {
  name: "Carolyn Gearig",
  title: "Junior UX Designer",
  picture: "//static.axios.com/img/headshots/carolyn-gearig.jpg"
}, {
  name: "Chris Barna",
  title: "Director, Engineering",
  picture: "//static.axios.com/img/headshots/chris-barna.jpg"
}, {
  name: "Chris Russell",
  title: "Expert Voices Editor",
  picture: "//static.axios.com/img/headshots/chris-russell.jpg"
}, {
  name: "Chris Canipe",
  title: "Senior Visual Journalist, Data Visualization",
  picture: "//static.axios.com/img/headshots/chris-canipe.jpg"
}, {
  name: "Claire Kennedy",
  title: "Senior Director, People Operations",
  picture: "//static.axios.com/img/headshots/ClaireKennedy.jpg"
}, {
  name: "Colin Chocola",
  title: "Producer, Axios Studios",
  picture: "//static.axios.com/img/headshots/colin-chocola.jpg"
}, {
  name: "Dan Primack",
  title: "Business Editor",
  picture: "//static.axios.com/img/headshots/DanPrimack.jpg"
}, {
  name: "Dave Lawler",
  title: "Associate Editor, World News",
  picture: "//static.axios.com/img/headshots/dave-lawler.jpg"
}, {
  name: "David McCabe",
  title: "Technology Reporter",
  picture: "//static.axios.com/img/headshots/DavidMcCabe.jpg"
}, {
  name: "David Nather",
  title: "Managing Editor, News",
  picture: "//static.axios.com/img/headshots/DavidNather.jpg"
}, {
  name: "Eileen O'Reilly",
  title: "Standards and Style Editor",
  picture: "//static.axios.com/img/headshots/eileen-oreilly.jpg"
}, {
  name: "Eli Sinkus",
  title: "Senior Producer",
  picture: "//static.axios.com/img/headshots/eli-sinkus.jpg"
}, {
  name: "Emma Schwartz",
  title: "Senior Director, Product",
  picture: "//static.axios.com/img/headshots/emma-schwartz.jpg"
}, {
  name: "Erica Pandey",
  title: "News Reporter",
  picture: "//static.axios.com/img/headshots/erica-pandey.jpg"
}, {
  name: "Erin Ross",
  title: "Science Reporter",
  picture: "//static.axios.com/img/headshots/erin-ross.jpg"
}, {
  name: "Evan Roseberry",
  title: "Shooter/Editor, Branded Video",
  picture: "//static.axios.com/img/headshots/evan-roseberry.jpg"
}, {
  name: "Gabe Newman",
  title: "Director, Account Management",
  picture: "//static.axios.com/img/headshots/gabe-newman.jpg"
}, {
  name: "Gerald Rich",
  title: "Senior Developer, News Products",
  picture: "//static.axios.com/img/headshots/gerald-rich.jpg"
}, {
  name: "Gloria Kim",
  title: "Senior UX Designer / Researcher",
  picture: "//static.axios.com/img/headshots/gloria-kim.jpg"
}, {
  name: "Greg Ruben",
  title: "Director, Product Design",
  picture: "//static.axios.com/img/headshots/GregRuben.jpg"
}, {
  name: "Grism Bolks",
  title: "Director, Data Engineering",
  picture: "//static.axios.com/img/headshots/grism-bolks.jpg"
}, {
  name: "Haley Britzky",
  title: "News Reporter",
  picture: "//static.axios.com/img/headshots/haley-britzky.jpg"
}, {
  name: "Ina Fried",
  title: "Chief Technology Correspondent",
  picture: "//static.axios.com/img/headshots/ina-fried.jpg"
}, {
  name: "Jillian Sobeck",
  title: "Account Manager",
  picture: "//static.axios.com/img/headshots/jillian-sobeck.jpg"
}, {
  name: "Joe Uchill",
  title: "Cybersecurity Reporter",
  picture: "//static.axios.com/img/headshots/team-placeholder.png"
}, {
  name: "Jonathan Swan",
  title: "National Political Reporter",
  picture: "//static.axios.com/img/headshots/JonathanSwan.jpg"
}, {
  name: "Joyce Kazadi",
  title: "Director, Events",
  picture: "//static.axios.com/img/headshots/JoyceKazadi.jpg"
}, {
  name: "Juliet Bartz",
  title: "Events Associate",
  picture: "//static.axios.com/img/headshots/juliet-bartz.jpg"
}, {
  name: "Justin Green",
  title: "Editor, News",
  picture: "//static.axios.com/img/headshots/JustinGreen.jpg"
}, {
  name: "Karina Carlson",
  title: "Associate Director, Events",
  picture: "//static.axios.com/img/headshots/KarinaCarlson.jpg"
}, {
  name: "Kate Meissner",
  title: "Vice President, Business Development",
  picture: "//static.axios.com/img/headshots/KateGaertner.jpg"
}, {
  name: "Kathleen Nisbet",
  title: "Senior Associate, Strategy",
  picture: "//static.axios.com/img/headshots/KathleenNisbet.jpg"
}, {
  name: "Kaya Baber",
  title: "Data Analytics Developer",
  picture: "//static.axios.com/img/headshots/kaya-baber.jpg"
}, {
  name: "Kayla Cook",
  title: "Chief of Staff",
  picture: "//static.axios.com/img/headshots/KaylaCook.jpg"
}, {
  name: "Kaylee Knowles",
  title: "Front-End Developer",
  picture: "//static.axios.com/img/headshots/kaylee-knowles.jpg"
}, {
  name: "Kerry McNellis",
  title: "Senior Director, Events",
  picture: "//static.axios.com/img/headshots/KerryMcNellis.jpg"
}, {
  name: "Khorri Atkinson",
  title: "News Reporter",
  picture: "//static.axios.com/img/headshots/khorri-atkinson.jpg"
}, {
  name: "Kia Kokalitcheva",
  title: "Reporter, Technology & Finance",
  picture: "//static.axios.com/img/headshots/kia-kokalitcheva.jpg"
}, {
  name: "Kim Hart",
  title: "Managing Editor",
  picture: "//static.axios.com/img/headshots/kim-hart.jpg"
}, {
  name: "Kim Schaich",
  title: "Senior Director",
  picture: "//static.axios.com/img/headshots/KimSchaich.jpg"
}, {
  name: "Kira Luca",
  title: "Director, Strategic Partnerships",
  picture: "//static.axios.com/img/headshots/kira-luca.jpg"
}, {
  name: "Kortni O'Donnell",
  title: "Office Manager",
  picture: "//static.axios.com/img/headshots/team-placeholder.png"
}, {
  name: "Lauren Meier",
  title: "Associate Editor, News",
  picture: "//static.axios.com/img/headshots/team-placeholder.png"
}, {
  name: "Lazaro Gamio",
  title: "Visuals Editor",
  picture: "//static.axios.com/img/headshots/lazaro-gamino.jpg"
}, {
  name: "Leigh Jervey",
  title: "Events Associate, Creative",
  picture: "//static.axios.com/img/headshots/leigh-jervey.jpg"
}, {
  name: "Megan Foley",
  title: "Creative Producer, Branded",
  picture: "//static.axios.com/img/headshots/megan-foley.jpg"
}, {
  name: "Melanie Singer",
  title: "Advertising Operations Associate",
  picture: "//static.axios.com/img/headshots/melanie-singer.jpg"
}, {
  name: "Morgan McCloy",
  title: "Shooter/Editor",
  picture: "//static.axios.com/img/headshots/morgan-mccloy.jpg"
}, {
  name: "Morgan Stanley",
  title: "Senior Associate, People Operations",
  picture: "//static.axios.com/img/headshots/morgan-stanley.jpg"
}, {
  name: "Neal Rothschild",
  title: "Associate Editor, Social",
  picture: "//static.axios.com/img/headshots/neal-rothschild.jpg"
}, {
  name: "Nick Bisby",
  title: "Systems Architect",
  picture: "//static.axios.com/img/headshots/nick-bisby.jpg"
}, {
  name: "Noa Gutterman",
  title: "Associate Director, Marketing",
  picture: "//static.axios.com/img/headshots/noa-gutterman.jpg"
}, {
  name: "Nora Okonski",
  title: "Director, Revenue Operations",
  picture: "//static.axios.com/img/headshots/nora-okonski.jpg"
}, {
  name: "Rachel Racoosin",
  title: "Director, Business Development",
  picture: "//static.axios.com/img/headshots/rachel-racoosin.jpg"
}, {
  name: "Rameez Tase",
  title: "Vice President, Audience Development and Insights",
  picture: "//static.axios.com/img/headshots/team-placeholder.png"
}, {
  name: "Rebecca Zisser",
  title: "Graphic Designer",
  picture: "//static.axios.com/img/headshots/RebeccaZisser.jpg"
}, {
  name: "Rob Groulx",
  title: "Creative Director",
  picture: "//static.axios.com/img/headshots/RobGroulx.jpg"
}, {
  name: "Sam Baker",
  title: "Editor, Health Care",
  picture: "//static.axios.com/img/headshots/sam-baker.jpg"
}, {
  name: "Sam Jacobson",
  title: "Director, Business Development",
  picture: "//static.axios.com/img/headshots/sam-jacobson.jpg"
}, {
  name: "Sam Jayne",
  title: "Art Director",
  picture: "//static.axios.com/img/headshots/sam-jayne.jpg"
}, {
  name: "Sara Fischer",
  title: "Media Reporter",
  picture: "//static.axios.com/img/headshots/SaraFischer.jpg"
}, {
  name: "Shane Savitsky",
  title: "News Reporter",
  picture: "//static.axios.com/img/headshots/ShaneSavitsky.jpg"
}, {
  name: "Shannon Vavra",
  title: "News Reporter",
  picture: "//static.axios.com/img/headshots/ShannonVavra.jpg"
}, {
  name: "Stef W. Kight",
  title: "News Reporter",
  picture: "//static.axios.com/img/headshots/StefWasko.jpg"
}, {
  name: "Steve LeVine",
  title: "Editor, Future of Work",
  picture: "//static.axios.com/img/headshots/steve-levine.jpg"
}, {
  name: "Taylor Poulos",
  title: "Product Designer",
  picture: "//static.axios.com/img/headshots/taylor-poulos.jpg"
}];


// WEBPACK FOOTER //
// ./src/about/components/About/teamInfo.js